var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "news_listing", staticClass: "news_listing scrollanchor" },
    [
      _c("div", { staticClass: "container-wrapper" }, [
        _c("div", { staticClass: "container top" }, [
          _c(
            "div",
            {
              staticClass: "upper_banner",
              class: {
                "no-filter":
                  _vm.show_filter === "" || _vm.paginatedData.length <= 1,
              },
            },
            [
              _c("h5", [_vm._v("Filter By")]),
              _vm._v(" "),
              _vm.show_filter === "on" ||
              (_vm.show_filter === "1" &&
                _vm.paginatedData.length >= 0 &&
                Object.keys(_vm.parsedCategories).length > 0)
                ? _c(
                    "ul",
                    { staticClass: "filter-cats" },
                    [
                      _c("secondary-button", {
                        class: { current: _vm.currentFilter == "all" },
                        attrs: { label: "All", link: false, theme: "filter" },
                        nativeOn: {
                          click: function ($event) {
                            _vm.currentFilter = "all"
                          },
                        },
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.parsedCategories, function (category, index) {
                        return _c("secondary-button", {
                          key: index,
                          class: {
                            current: category.slug == _vm.currentFilter,
                          },
                          attrs: {
                            id: category.id,
                            label: category.name,
                            link: false,
                            theme: "filter",
                          },
                          nativeOn: {
                            click: function ($event) {
                              _vm.currentFilter === category.slug
                                ? (_vm.currentFilter = "all")
                                : (_vm.currentFilter = category.slug)
                            },
                          },
                        })
                      }),
                    ],
                    2
                  )
                : _vm._e(),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "container bottom" },
        [
          _c("div", { staticClass: "lower_banner" }, [
            _c(
              "div",
              { staticClass: "no-posts counts" },
              [
                _vm.paginatedData.length === 0 && !_vm.busy
                  ? _c("h4", {
                      staticClass: "no-posts",
                      domProps: { innerHTML: _vm._s(_vm.no_posts_message) },
                    })
                  : _vm.paginatedData.length != 0 && !_vm.busy
                  ? _c("h4", {
                      staticClass: "no-posts",
                      domProps: { innerHTML: _vm._s(_vm.showingOf) },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.busy === true ? _c("loading-animation") : _vm._e(),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          [
            _vm.busy != true
              ? _vm._l(_vm.paginatedData, function (post, index) {
                  return _c("post-tile", {
                    key: index,
                    class: post.post_type,
                    attrs: {
                      name: post.title,
                      short_description: post.excerpt,
                      image: post.image,
                      permalink: {
                        url: post.permalink,
                        target: "_self",
                        title: "Read More",
                      },
                      tag: post.category,
                      post_type: post.post_type,
                      video: false,
                      "data-aos": "fade-up",
                      "data-aos-duration": "300",
                      "data-aos-offset": 50,
                      "data-aos-delay": index * 50,
                    },
                  })
                })
              : _vm._e(),
          ],
          _vm._v(" "),
          _vm.pageCount != 1 &&
          _vm.show_pagination === "1" &&
          _vm.paginatedData.length != 0
            ? _c(
                "ul",
                { staticClass: "page-numbers" },
                [
                  _vm.pageNumber != 0
                    ? _c("li", [
                        _c(
                          "a",
                          {
                            staticClass: "prev page-numbers",
                            on: {
                              click: function ($event) {
                                _vm.pageNumber--
                              },
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "arrow_container" },
                              [_c("chevron-right")],
                              1
                            ),
                            _vm._v(" "),
                            _c("span", [_vm._v("Previous")]),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.pageCount, function (post, index) {
                    return _c("li", { key: index }, [
                      _c("a", {
                        staticClass: "page-numbers",
                        class: { current: index == _vm.pageNumber },
                        domProps: { innerHTML: _vm._s(index + 1) },
                        on: {
                          click: function ($event) {
                            _vm.pageNumber = index
                          },
                        },
                      }),
                    ])
                  }),
                  _vm._v(" "),
                  _vm.pageNumber != _vm.pageCount - 1
                    ? _c("li", [
                        _c(
                          "a",
                          {
                            staticClass: "next page-numbers",
                            on: {
                              click: function ($event) {
                                _vm.pageNumber++
                              },
                            },
                          },
                          [
                            _c("span", [_vm._v("Next")]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "arrow_container" },
                              [_c("chevron-right")],
                              1
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                ],
                2
              )
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }